import { axiosInstance as request } from '@api/rest.service'
import { getFilters } from '@/modular-api/utils'

const api = '/subscriptions'

/**
 * @description GET /subscriptions?paginated=true (+ag grid filter model, +badge filters)
 * @returns {AxiosPromise<any>}
 */
export const GET_PAGINATED_SUBSCRIPTIONS = (params, filters) => {
  const paramsWithFilters = {
    ...getFilters(filters),
    ...params
  }

  return request.get(`${api}?paginated=true`, { params: paramsWithFilters })
}

/**
 * @description GET /subscriptions/${subscriptionId}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION = subscriptionId => request.get(`${api}/${subscriptionId}`)

/**
 * @description PATCH /subscriptions/${subscriptionId}
 * @returns {AxiosPromise<any>}
 */
export const MODIFY_SUBSCRIPTION = (subscriptionId, payload) => request.patch(`${api}/${subscriptionId}`, payload)

/**
 * @description DELETE /subscriptions/${subscriptionId}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_SUBSCRIPTION = subscriptionId => request.delete(`${api}/${subscriptionId}`)

/**
 * @description GET /subscriptions/${subscriptionId}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_DELETE_CONFIRMATION = subscriptionId =>
  request.get(`${api}/${subscriptionId}/delete-confirmation`)

/**
 * @description GET /subscriptions/${subscriptionId}/subscription-periods
 * @returns {AxiosPromise<any>}
 */
export const GET_PERIODS_OF_SUBSCRIPTION = subscriptionId =>
  request.get(`${api}/${subscriptionId}/subscription-periods`)
